import auditStyles from './audit/layout.module.css';
import broadcastStyles from './broadcast/layout.module.css';

import {isAudit} from "../../helpers/relay";

export default isAudit() ? auditStyles : broadcastStyles;
